"use client";
import { useEffect, useState } from "react";
import UserCompanyDetailForm from "./UserCompanyDetailForm";
import BookingTable from "./common/Table";
import { Building2, Pencil, Trash } from "lucide-react";
import {
  useGetCities,
  useGetCompanyDetail,
  useGetCompanyDetailsId,
  useGetCountries,
  useGetStates,
  useGetUserCompanyInfo,
  useUpateBranchStatus,
  //   useGetCompanyDetailsById,
} from "@/hooks/useCommon";
import { toast } from "react-toastify";

interface branchDetail {
  branch_code: number;
  branch_name: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
}

interface Column {
  key: string;
  header: string;
  sortable?: boolean;
  filterable?: boolean;
  filterType?: any;
  render?: (value: any, row?: any) => React.ReactNode;
  hidden?: boolean;
}

export default function MasterCompanyDetailComponnent() {
  const [counter, setCounter] = useState<number>(1);
  const [id, setId] = useState<number>(0);
  const [data, setData] = useState<any>(null);

  // const { data: companyData, refetch: refetchCompanyData } =
  //   useGetCompanyDetail();

  const { data: companyDetailsData } = useGetUserCompanyInfo();

  const { mutate: branchToggle } = useUpateBranchStatus();

  const unAssignedData: branchDetail[] = Array.isArray(companyDetailsData)
  ? companyDetailsData.map((item: any, index: number) => ({
      branch_code: item?.id,
      branch_name: item?.company_name || "",
      address: item?.company_address || "",
      city: item?.name || '-',
      country: item?.country_name || '-',
      state: item?.state_name || '-',
      pincode: item?.companyData?.pincode || "",
      branch: item?.branch == 1 ? "BRANCH" : "HEAD OFFICE"
    }))
  : [];


  const handleEdit = (data: any) => {
    setId(data.branch_code);
  };
  const handleStatusToggle = (branch_code: number, newBranchValue: string) => {

    const requestData = {
      id: branch_code,
      branch: parseInt(newBranchValue), // Ensure it's a number
    };

    branchToggle(requestData, {
      onSuccess: (response) => {
        // refetchCompanyData();
        toast.success("Branch Updated successfully!");
      },
      onError: (error) => {
        toast.error("Failed to update branch status");
      },
    });
  };
  const bankDetailColumns: Column[] = [
    {
      key: "branch_code",
      header: "Branch Code",
      sortable: true,
      filterable: true,
    },
    {
      key: "branch_name",
      header: "Branch Name",
      sortable: true,
      filterable: true,
    },
    {
      key: "country",
      header: "Country",
      sortable: true,
      filterable: true,
    },
    {
      key: "state",
      header: "State",
      sortable: true,
      filterable: true,
    },
    {
      key: "city",
      header: "City",
      sortable: true,
      filterable: true,
    },
    {
      key: "branch",
      header: "Branch",
      sortable: true,
      filterable: true,
    },
    {
      key: "address",
      header: "Address",
      sortable: true,
      filterable: true,
      render: (_: string, row: any) => (
        <div
          className="text-gray-600 truncate max-w-[120px]"
          title={row.address}
        >
          {row.address}
        </div>
      ),
    },

    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (_: string, row: any) => (
        <div className="flex items-center gap-1">
          <button
            onClick={() => handleEdit(row)}
            className="text-blue-600 text-xs hover:text-blue-800 font-medium cursor-pointer"
          >
            <Pencil className="w-4 h-4" />
          </button>
          <select
            className="border border-gray-200 outline-none px-2"
            // defaultValue={row.branch}
            value={row.branch === "BRANCH" ? "1" : "0"}
            onChange={() =>
              handleStatusToggle(
                row.branch_code,
                row.branch === "BRANCH" ? "1" : "0"
              )
            }
          >
            <option value="1">Branch</option>
            <option value="0">Head Office</option>
          </select>
        </div>
      ),
    },
  ];

  

  return (
    <div className="w-full bg-white">
      <div className="flex items-center gap-3 pb-3 border-b border-gray-200 p-4">
        <div className="p-2 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg">
          <Building2 className="w-3 h-3 text-white" />
        </div>
        <h3 className="text-[16px] font-semibold text-gray-800">
          Company Details
        </h3>
      </div>
      {Array(counter)
        .fill("")
        .map((item, idx) => (
          <div key={idx}>
            {idx > 0 && <hr className="border-t border-gray-100 mx-6" />}
            {counter > 1 && idx > 0 && (
              <button
                type="button"
                onClick={() => setCounter(counter > 1 ? counter - 1 : 1)}
                className="text-xs text-red-500 rounded-full hover:text-red-600 float-right mr-5 cursor-pointer mt-3 hover:bg-red-50 p-1 "
              >
                <Trash className="w-4 h-4" />
              </button>
            )}
            <UserCompanyDetailForm
              key={idx}
              setCounter={setCounter}
              counter={counter}
              id={id}
            />
          </div>
        ))}

      <div className="mt-4 flex justify-end px-5">
        <button
          type="button"
          onClick={() => {
            setCounter((prev: any) => prev + 1);
          }}
          disabled={id != 0}
          className="text-[12px] py-1 px-3 rounded-md bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md hover:from-blue-700 hover:to-purple-700 cursor-pointer disabled:cursor-not-allowed"
        >
          + Add Branch
        </button>
      </div>

      <div className="py-5 px-7">
        <BookingTable
          data={unAssignedData}
          columns={bankDetailColumns}
          searchable={true}
          filterable={true}
          sortable={false}
        />
      </div>
    </div>
  );
}
